import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=1410e752&scoped=true&"
import script from "./TabsContainer.vue?vue&type=script&lang=js&"
export * from "./TabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabsContainer.vue?vue&type=style&index=0&id=1410e752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410e752",
  null
  
)

export default component.exports